module.exports = __webpack_public_path__ + "files/6f62c57d6817fd4eeaecee479afd532c.png";